import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../collections/CollectionsKt.mjs';
import { listOfvhqybd2zx248 as listOf } from '../collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  TakeSequencecj2mz1r3ww35 as TakeSequence,
  DropTakeSequence18qfczyunxcax as DropTakeSequence,
  emptySequence25zpp7hgtqwdd as emptySequence,
} from './Sequences.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function first(_this__u8e3s4) {
  var iterator = _this__u8e3s4.p1();
  if (!iterator.q1())
    throw NoSuchElementException().a2('Sequence is empty.');
  return iterator.r1();
}
function toList(_this__u8e3s4) {
  var it = _this__u8e3s4.p1();
  if (!it.q1())
    return emptyList();
  var element = it.r1();
  if (!it.q1())
    return listOf(element);
  var dst = ArrayList().p2();
  dst.i2(element);
  while (it.q1()) {
    dst.i2(it.r1());
  }
  return dst;
}
function take(_this__u8e3s4, n) {
  // Inline function 'kotlin.require' call
  if (!(n >= 0)) {
    var message = 'Requested element count ' + n + ' is less than zero.';
    throw IllegalArgumentException().n2(toString(message));
  }
  var tmp;
  if (n === 0) {
    tmp = emptySequence();
  } else {
    if (isInterface(_this__u8e3s4, DropTakeSequence())) {
      tmp = _this__u8e3s4.u3(n);
    } else {
      tmp = new (TakeSequence())(_this__u8e3s4, n);
    }
  }
  return tmp;
}
function asIterable(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new (asIterable$$inlined$Iterable$1())(_this__u8e3s4);
}
var asIterable$$inlined$Iterable$1Class;
function asIterable$$inlined$Iterable$1() {
  if (asIterable$$inlined$Iterable$1Class === VOID) {
    class $ {
      constructor($this_asIterable) {
        this.v3_1 = $this_asIterable;
      }
      p1() {
        return this.v3_1.p1();
      }
    }
    initMetadataForClass($);
    asIterable$$inlined$Iterable$1Class = $;
  }
  return asIterable$$inlined$Iterable$1Class;
}
//region block: exports
export {
  asIterable as asIterable1fxmj7vyh9cyo,
  first as firstqtqxwgtggxw8,
  take as take2rh6pen3z50h7,
  toList as toListx6x8nvfmvvht,
};
//endregion

//# sourceMappingURL=_Sequences.mjs.map
